module.exports = __webpack_public_path__ + "static/img/15.f685341.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/3/sp/15.png
// module id = fedw
// module chunks = 0